import { Link } from "react-scroll"
import { useState, useEffect } from "react"
import axios from "axios"
import '../css/premios.css'
import ButtonUp from "./ButtonUp"
import premio1 from "../img/IMG-_1_.webp"
import premio2 from "../img/1-_1_.webp"



const Premios = () => {


    const [db, setDb] = useState([])
    const [orden, setOrden] = useState([])


    const getData = async () => {
        const ENDPOINT = "https://elsaback-q7jq.onrender.com/premios"
        const res = await axios.get(ENDPOINT),
            json = await res.data;

        setDb(json)
    }

    useEffect(() => {


        getData()
    }, [])


    useEffect(() => {
        const orden = [...db].sort((a, b) => b.month - a.month).sort((a, b) => b.year - a.year)


        setOrden(orden)
    }, [db])
   



    return (
        <div className='intro' style={{ width: '85%', position: 'relative' }}>
            <ButtonUp />
            <h2 id='prem'>Premios</h2>
            <div className="divLink">
                <div className="linkPremios"><Link className="linkTexto" to="2025" smooth={true} offset={-75} duration={500}>2025</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2023" smooth={true} offset={-75} duration={500}>2023</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2022" smooth={true} offset={-75} duration={500}>2022</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2019" smooth={true} offset={-75} duration={500}>2019</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2014" smooth={true} offset={-75} duration={500}>2014</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2013" smooth={true} offset={-75} duration={500}>2013</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2012" smooth={true} offset={-75} duration={500}>2012</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2011" smooth={true} offset={-75} duration={500}>2011</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2010" smooth={true} offset={-75} duration={500}>2010</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2009" smooth={true} offset={-75} duration={500}>2009</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2008" smooth={true} offset={-75} duration={500}>2008</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2006" smooth={true} offset={-75} duration={500}>2006</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2005" smooth={true} offset={-75} duration={500}>2005</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2004" smooth={true} offset={-75} duration={500}>2004</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="2003" smooth={true} offset={-75} duration={500}>2003</Link></div>
                <div className="linkPremios"><Link className="linkTexto" to="1998" smooth={true} offset={-75} duration={500}>1998</Link></div>

            </div>
           
                {[...new Set(orden.map(item => item.year))].map((year) => (
                    <div className="divPremios"  key={year} id={year}>
                        <h3>{year}</h3>
                        <ul>
                        {orden
                            .filter(item => item.year === year)
                            .map(item => (
                                <div key={item._id} className="divPremio">
                                    <li>{item.description}</li>
                                    {
                                        item.image ? (<img src={item.image} alt="premio" /> ) : null
                                    }
                                    
                                </div>
                            ))
                        }
                        </ul>
                    </div>
                ))}
            


        </div>
    )
}

export default Premios